$(document).ready(function () {
    console.log("ready!");

    $('.slick-slider').slick({
        autoplay: true,
        autoplaySpeed: 10000,
        dots: true,
        infinite: false,
        speed: 500,
        fade: true,
        cssEase: 'linear'
    });

    $("#register_form").validate({
        rules: {
            name: "required",
            phone: "required",
            terms: "required",
            email: {
                required: !0,
                email: !0
            }
        },
        submitHandler: function (form) {
            $("#loader").show();
            var t = $("#name").val(),
                n = $("#email").val(),
                i = $("#phone").val();
            $.ajax({
                url: "php/form-process.php",
                type: "POST",
                data: "name=" + t + "&email=" + n + "&message=" + i,
                success: function (data) {
                    if (data == "success") {
                        $("#loader").hide()
                        $("#successModal").modal("show");
                        setCookie('played', 'yes', 365);
                        $('#register_form input, #register_form button').prop('disabled', true);
                    }
                }
            });
            return false;
        }
    });

    $('input[name="customRadio"]').on('change', function (e) {
        $('#right, #wrong').addClass('d-none');
        if ($(this).val() == '8' && !getCookie('played')) {
            $('#right').removeClass('d-none');
            $('input[name="customRadio"]').prop('disabled', true);
            $('#register_form input, #register_form button').prop('disabled', false);
        } else {
            $('#wrong').removeClass('d-none');
            $('#register_form input, #register_form button').prop('disabled', true);

            setTimeout(function () {
                $('#right, #wrong').addClass('d-none');
            }, 2000);
        }
    });   

    if (getCookie('played')) {       
        $('#register_form input, #register_form button').prop('disabled', true);
    }

});

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function eraseCookie(name) {
    createCookie(name, "", -1);
}
